import { TFunction } from 'i18next';
import {
  evidenceAuditRefusalNoCredits,
  evidenceAuditRefusalNoCriteria,
  evidenceAuditRefusalNoSet,
  evidenceAuditRefusalNotAuthorized,
} from 'models/auditCriteriaGenericSets';

/**
 * Why the AI evidence audit (PLAN-077) did not start, in the user's language: the reason the server names on the
 * audit's line, told by the start card and by the assessment task's AI pane.
 */
export const getEvidenceAuditRefusalText = (reason: string | undefined, t: TFunction): string => {
  switch (reason) {
    case evidenceAuditRefusalNoCredits:
      return t('criteria:Generic.Start.EvidenceAuditReason.NoCredits');
    case evidenceAuditRefusalNotAuthorized:
      return t('criteria:Generic.Start.EvidenceAuditReason.NotAuthorized');
    case evidenceAuditRefusalNoSet:
      return t('criteria:Generic.Start.EvidenceAuditReason.NoSet');
    case evidenceAuditRefusalNoCriteria:
      return t('criteria:Generic.Start.EvidenceAuditReason.NoCriteria');
    default:
      return t('criteria:Generic.Start.EvidenceAuditReason.Failed');
  }
};
